const updateMiniCart = function updateMiniCart() {
    let canvas = $('#offcanvasMiniCart');

    let image_html = function (item) {
        if (item.image) {
            return `<img src="${item.image}" class="img-fluid" title="${item.name}" alt="${item.name}">`;
        } else {
            return `<div class="is-no-image"><i class="fal fa-image is-icon--xl"></i></div>`;
        }
    }


    return window.axios.get(window.config.urls.miniCart).then((response) => {
        let data = response.data;
        if (data.items) {
            let template = document.querySelector('#mini-cart-item');
            let miniCartBody = $('#miniCartBody');
            miniCartBody.html('');
            miniCartBody.attr("data-cart-id", data.cartId);
            data.items.forEach(function (item, index) {
                let name = '<p class="h6 mb-0">' + item.name + '</p>';
                let details = '<small>' + item.details + '</small>';
                let followUpButton = '';
                if (item.hasFollowUp) {
                    name = '<p class="h6 mb-0 follow-up">' + item.name + '</p>';
                    details = '<small>' + item.followUpMessage + '</small>';
                    followUpButton = '<button data-cart-id="' + data.cartId + '" data-row-id="' + item.rowId +
                        '" class="px-2 follow-up-cart btn btn-icon-light btn-md" type="button" data-action="update-mini-cart" title="' + item.followUpTooltip + '">' +
                        ' <i class="is-icon fas fa-fw fa-clone fa-md"></i> </button>';
                }
                let quantityInput = `<span>${item.quantity_formatted}</span>`;
                if (!item.hasOwnProperty('editable') || item.editable) {
                    quantityInput = `<div class="is-number-input d-inline-flex border flex-column flex-lg-row">
                                <button class="is-number-input__up btn" >
                                    <i class="far fa-plus"></i>
                                </button>
                                <input
                                    class="is-number-input__input text-center mini-cart"
                                    type="number"
                                    value="${item.quantity}"
                                    data-min="${item.minimum}"
                                    data-step="${item.step}"
                                  />
                                <button class="is-number-input__down btn" >
                                    <i class="far fa-minus"></i>
                                </button>
                            </div>`
                }
                miniCartBody.append(
                    `<div class="row fill-width m-0 is-mini-cart-item d-flex align-items-center border-bottom py-3">
                    <form method="post">
                        <input type="hidden" name="${item.rowId}[quantity]" value="" class="quantity">
                        <input type="hidden" name="${item.rowId}[rowId]" value="${item.rowId}" class="rowId">
                        <input type="hidden" name="${item.rowId}[id]" value="${item.id}" class="id">
                    </form>

                    <div class="col-2 is-mini-cart-item__image-wrap">
                        ${image_html(item)}
                    </div>

                    <div class="col-6 col-md-4">
                        ${name}

                        ${details}
                    </div>

                    <div class="col-2 d-none d-md-block">
                        <span>${item.sum}</span>
                    </div>

                    <div class="col-4 col-sm-3 col-md-2 text-end">

                        ${quantityInput}

                        <div class="text-end pt-1">
                            <span>${item.quantityUnit}</span>
                        </div>

                        <div class="text-center d-md-none">
                            ${followUpButton}
                            <button type="button" class="btn btn-icon-light px-1 delete-mini-cart-item" data-cart-id="${data.cartId}"
                                    data-row-id="${item.rowId}" data-product-number="${item.number}" data-product-name="${item.name}"
                                    data-price="${item.sum_raw}" data-action="update-mini-cart">
                                <i class="is-icon text-danger fas fa-times-circle"></i>
                            </button>
                        </div>
                    </div>

                    <div class="col-1 d-none d-md-block text-end">
                        ${followUpButton}
                        <button type="button" class="btn btn-icon-light px-1 delete-mini-cart-item" data-cart-id="${data.cartId}"
                                    data-row-id="${item.rowId}" data-product-number="${item.number}" data-product-name="${item.name}"
                                    data-price="${item.sum_raw}" data-action="update-mini-cart">
                            <i class="is-icon text-danger fas fa-times-circle"></i>
                        </button>
                    </div>
                </div>`
                );
            });

            if (Number(data.items.length) === 0) {
                miniCartBody.append(
                    `<div class="container border-info">
                        <div role="alert" class="alert alert-info">
                            ${data.message}
                        </div>
                    </div>`
                );
            }

            document.querySelector('#miniCartTotal').textContent = data.sum;
            canvas.show();
        }
        return response;
    }).catch((error) => {
        console.log(error);
    });
}

export default updateMiniCart;
